import { ConnectorSwitchService } from '../../../../../services/connector-switch.service';
import {
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import {
  ConnectorSwitchViewModel,
  EditConnectorSwitchDto,
  EquipmentSourceDestination,
} from '../../../../../models/connector-switch.model';
import { BaseVoltageService } from '../../../../../services/base-voltage.service';
import { CimSubstationService } from '../../../../../services/cim-substation.service';
import { SubstationTemplateForSelectDataOut } from '../../../../../models/substation-template.model';
import { SelectSubstationDto } from '../../../../../models/substation-template-instance.model';
import { ObjectDropdownComponent } from '../../../../common/object-dropdown/object-dropdown.component';
import { UtilitySharedService } from '../../../../../services/shared/utility-shared.service';
import { CimClass } from '../../../../../models/network-structure.model';

@Component({
  selector: 'lib-nec-add-edit-modal-connector-switch',
  templateUrl: './nec-add-edit-modal-connector-switch.component.html',
  styleUrls: [
    './nec-add-edit-modal-connector-switch.component.scss',
    '../../../network-entity-classes.component.scss',
  ],
  standalone: false,
})
export class NecAddEditModalConnectorSwitchComponent {
  @Input() selectedEquipment!: {
    value: string;
    text: string;
    count: number;
    active?: boolean;
  };
  @Input() tabsTypes!: { value: string; text: string }[];
  @Input() entityName: string | null = null;
  @Input() activeItemId!: number;
  @Input() isOpenedFromSubstation: boolean = false;
  @Input() selectedEquipmentId: { value: number | null } | null = null;
  @Input() tabs: { value: string; text: string; count: number }[] = [];
  @Input() selectedTab!: {
    value: string;
    text: string;
    count: number;
    active?: boolean;
  };
  @Input() substationTemplateInstanceIdFromSubstation: number | null = null;
  @Input() selectedEquipmentType: any = null;

  @Output() equipmentSaved = new EventEmitter<void>();

  @ViewChild('closeEditModal') closeEditModal!: ElementRef;
  @ViewChild('substationTemplateDropdown')
  substationTemplateDropdown!: ObjectDropdownComponent;
  @ViewChild('substationTemplateInstanceDropdown')
  substationTemplateInstanceDropdown!: ObjectDropdownComponent;
  @ViewChild('dropdownVoltage') dropdownVoltage!: ObjectDropdownComponent;
  @ViewChild('destinationEquipmentDropdown')
  destinationEquipmentDropdown!: ObjectDropdownComponent;
  @ViewChild('sourceEquipmentDropdown')
  sourceEquipmentDropdown!: ObjectDropdownComponent;

  entities: ConnectorSwitchViewModel[] = [];

  currentPage: number = 1;
  pageSize: number = 10;
  pageSizes = [10, 20];
  count: number = 1;

  filterOpened: boolean = false;
  searchDropdownOpened: boolean = false;

  isEdit: boolean = false;
  actionMenuOpenForId: number | null = null;

  selectedEntity: EditConnectorSwitchDto = new EditConnectorSwitchDto();
  currentConnectorType!: { value: string; text: string };

  baseVoltages: any[] = [];
  substationTemplateOptions: SubstationTemplateForSelectDataOut[] = [];

  substationEquipmentOptions: EquipmentSourceDestination[] = [];

  sourcesMultiSelect: EquipmentSourceDestination[] = [];

  destinationsMultiSelect: EquipmentSourceDestination[] = [];

  sourcesDisplay?: string = '';
  destinationsDisplay?: string = '';

  baseVoltageValue: any | null = null;

  substationOptions: SelectSubstationDto[] = [];
  utilityId: number | null = 0;

  allTypes: { value: string; text: string }[] = [
    { value: CimClass[CimClass.Busbar], text: 'Busbar' },
    { value: CimClass[CimClass.Junction], text: 'Junction' },
    { value: CimClass[CimClass.Jumper], text: 'Jumper' },
    { value: CimClass[CimClass.Fuse], text: 'Fuse' },
    { value: CimClass[CimClass.Disconnector], text: 'Disconnector' },
    {
      value: CimClass[CimClass.GroundDisconnector],
      text: 'Ground Disconnector',
    },
    { value: CimClass[CimClass.Breaker], text: 'Circuit Breaker' },
    { value: CimClass[CimClass.LoadBreakSwitch], text: 'Load Break Switch' },
    { value: CimClass[CimClass.Ground], text: 'Ground' },
    { value: CimClass[CimClass.Cut], text: 'Cut' },
    { value: CimClass[CimClass.Recloser], text: 'Recloser' },
    { value: CimClass[CimClass.Sectionaliser], text: 'Sectionaliser ' },
    { value: CimClass[CimClass.PetersenCoil], text: 'Petersen Coil' },
    { value: CimClass[CimClass.ShuntCompensator], text: 'Shunt Compensator' },
    {
      value: CimClass[CimClass.FrequencyConverter],
      text: 'Frequency Converter',
    },
    {
      value: CimClass[CimClass.StaticVarCompensator],
      text: 'Static Var Compensator ',
    },
    {
      value: CimClass[CimClass.AcLineSegment],
      text: 'Incomer AC Line Segment ',
    },
  ];

  constructor(
    private connectorSwitchService: ConnectorSwitchService,
    private baseVoltageService: BaseVoltageService,
    private cimSubstationService: CimSubstationService,
    private utilitySharedService: UtilitySharedService,
    private toastr: ToastrService,
  ) {
    this.utilityId = utilitySharedService.getUtilityId();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['selectedEquipmentType']?.currentValue && !this.isEdit) {
      const type = changes['selectedEquipmentType'].currentValue;

      this.currentConnectorType = {
        value: type.value,
        text: type.name,
      };

      this.selectedEntity.equipmentType = type.value;
    }

    const change = changes['selectedEquipmentId'];
    if (change) {
      const newValue = change.currentValue;

      if (newValue && newValue.value !== 0) {
        this.isEdit = true;
        this.getAllBaseVoltagesForSelect();
        this.getById(newValue.value);
      } else {
        this.isEdit = false;
        this.selectedEntity.id = null;
      }
    }

    const idChange = changes['substationTemplateInstanceIdFromSubstation'];
    if (idChange?.currentValue) {
      this.selectedEntity.substationTemplateInstanceId = idChange.currentValue;
      this.getAllSubstationEquipmentForSelect();
      this.getAllBaseVoltagesForSelect();
    }
  }

  ngOnInit(): void {
    if (!this.selectedTab && this.tabs?.length) {
      this.selectedTab = this.tabs[0];
    }

    if (
      this.isOpenedFromSubstation &&
      this.substationTemplateInstanceIdFromSubstation
    ) {
      this.selectedEntity.substationTemplateInstanceId =
        this.substationTemplateInstanceIdFromSubstation;
    }

    if (!this.isEdit && this.selectedEquipmentType) {
      this.currentConnectorType = {
        value: this.selectedEquipmentType.value,
        text: this.selectedEquipmentType.name,
      };
      this.selectedEntity.equipmentType = this.selectedEquipmentType.value;
    }

    this.getAllBaseVoltagesForSelect();
    this.getAllSubstationTemplateForSelect();
  }

  onSelectBaseVoltage(obj: any | null) {
    if (obj) this.selectedEntity.baseVoltageId = obj.id ?? 0;
  }

  getAllBaseVoltagesForSelect() {
    this.baseVoltageService.getAllForMappings(this.utilityId!).subscribe({
      next: (response) => {
        const responseData = response.body;
        if (responseData?.status === 200 || responseData?.status === 'OK') {
          this.baseVoltages = responseData.data;
        } else if (response?.status === 204) {
          this.baseVoltages = [];
        } else {
          this.toastr.error(responseData?.message);
        }
      },
      error: (_) => {
        this.toastr.error('Error occurred while loading base voltages');
      },
    });
  }

  getAllSubstationTemplateForSelect() {
    this.cimSubstationService.getStats().subscribe({
      next: (response: any) => {
        const responseData = response.body;
        if (responseData?.status === 'OK') {
          this.substationTemplateOptions = responseData.data.map(
            (item: any) => new SubstationTemplateForSelectDataOut(item),
          );
        } else if (response?.status !== 'OK') {
          this.substationTemplateOptions = [];
        } else {
          this.toastr.error(responseData?.message);
        }
      },
      error: (_) => {
        this.toastr.error('Error occurred while loading substation templates');
      },
    });
  }

  getAllSubstationEquipmentForSelect() {
    if (!this.selectedEntity.substationTemplateInstanceId) return;

    let dataIn = {
      id: this.selectedEntity.substationTemplateInstanceId,
      equipmentType: this.selectedEquipmentType.value,
    };

    this.connectorSwitchService.getEquipmentBySsId(dataIn).subscribe({
      next: (response: any) => {
        const responseData = response.body;
        if (responseData?.status === 'OK') {
          this.substationEquipmentOptions = responseData.data;
          this.filterEquipmentSourceDestination();
        }
      },
      error: (_) => {
        this.toastr.error('Error occurred while loading substation equipment');
      },
    });
  }

  filterEquipmentSourceDestination(filterType?: number) {
    // 1 for source, 2 for destination, null for all
    const isAcLineSegment =
      this.selectedEquipmentType.value!.toString() == 'AcLineSegment';

    if (!filterType || filterType == 1) {
      this.sourcesMultiSelect = this.substationEquipmentOptions.filter(
        (x) =>
          !x.hasDestination &&
          !this.selectedEntity.destinationEquipmentIds.includes(x.id) &&
          (!isAcLineSegment ||
            x.equipmentType!.toString() == 'PowerTransformer'),
      );
    }

    if (!filterType || filterType == 2) {
      this.destinationsMultiSelect = this.substationEquipmentOptions.filter(
        (x) =>
          !x.hasSource &&
          !this.selectedEntity.sourceEquipmentIds.includes(x.id) &&
          (!isAcLineSegment || x.equipmentType!.toString() == 'Busbar'),
      );
    }
  }
  onSelectSubstationTemplate(obj: SubstationTemplateForSelectDataOut | null) {
    if (obj != null && obj.id != null) {
      this.selectedEntity.equipmentContainerId = obj.id;
      this.selectedEntity.substationTemplateInstanceId = null;
      this.destinationEquipmentDropdown?.selectItem(null);
      this.sourceEquipmentDropdown?.selectItem(null);
      this.substationTemplateInstanceDropdown?.selectItem(null);
    }
  }

  onSelectSubstationTemplateInstance(obj: SelectSubstationDto | null) {
    if (obj?.id) {
      this.selectedEntity.substationTemplateInstanceId =
        obj.substationTemplateInstanceId;
      this.getAllSubstationEquipmentForSelect();
    }
  }

  onSearchTextChange(inputText: string) {
    if (
      this.selectedEntity.equipmentContainerId &&
      this.selectedEntity.equipmentContainerId > 0
    ) {
      this.getAllSubstationInstancesForType(
        this.selectedEntity.equipmentContainerId,
        inputText,
      );
    }
  }

  onSelectMultiDestinationEquipment(
    selectedDestinations: EquipmentSourceDestination[],
  ) {
    this.selectedEntity.destinationEquipmentIds = selectedDestinations.map(
      (x) => x.id,
    );

    this.filterSourceEquipment();
  }

  onSelectMultiSourceEquipment(selectedSources: EquipmentSourceDestination[]) {
    this.selectedEntity.sourceEquipmentIds = selectedSources.map((x) => x.id);
    this.filterDestinationEquipment();
  }

  onSelectSourceEquipment(obj: any) {
    if (obj) {
      this.selectedEntity.sourceEquipmentIds = [obj.id];
      this.filterEquipmentSourceDestination(2);
    }
  }

  onSelectDestinationEquipment(obj: any) {
    if (obj) {
      this.selectedEntity.destinationEquipmentIds = [obj.id];
      this.filterEquipmentSourceDestination(1);
    }
  }

  filterSourceEquipment() {
    this.sourcesMultiSelect = this.substationEquipmentOptions.filter(
      (x) => !this.selectedEntity.destinationEquipmentIds.includes(x.id),
    );
  }

  filterDestinationEquipment() {
    this.destinationsMultiSelect = this.substationEquipmentOptions.filter(
      (x) => !this.selectedEntity.sourceEquipmentIds.includes(x.id),
    );
  }

  getAllSubstationInstancesForType(
    templateId: number,
    searchTerm: string = '',
  ) {
    this.cimSubstationService
      .getAllForSelect({ templateId, searchTerm })
      .subscribe({
        next: (response: any) => {
          const responseData = response.body;
          if (responseData?.status === 'OK') {
            this.substationOptions = responseData.data;
          } else if (response?.status !== 'OK') {
            this.substationOptions = [];
          }
        },
        error: (error) => {
          this.toastr.error('Error occurred while loading substation options');
        },
      });
  }

  getById(id: number) {
    this.connectorSwitchService.getById(id).subscribe({
      next: (response: any) => {
        const responseData = response.body;
        if (responseData?.status === 'OK') {
          if (responseData.data) {
            this.selectedEntity = new EditConnectorSwitchDto(responseData.data);
            if (this.isEdit && responseData.data.baseVoltage) {
              this.baseVoltageValue =
                this.baseVoltages.find(
                  (bv) => bv.id === responseData.data.baseVoltage.id,
                ) ?? null;
            } else if (this.selectedEntity?.baseVoltageId)
              this.baseVoltageValue =
                this.baseVoltages.find(
                  (bv) => bv.id === this.selectedEntity.baseVoltageId,
                ) ?? null;

            this.currentConnectorType = this.allTypes.find(
              (t) => t.value === this.selectedEntity.equipmentType,
            )!;

            this.destinationEquipmentDropdown?.selectItem(null);
            this.sourceEquipmentDropdown?.selectItem(null);

            this.sourcesDisplay = this.selectedEntity.sourceEquipment
              ?.map((x) => x.name)
              .join(', ');

            this.destinationsDisplay = this.selectedEntity.destinationEquipment
              ?.map((x) => x.name)
              .join(', ');

            this.getAllSubstationEquipmentForSelect();
          }
        }
      },
      error: (error) => {
        this.toastr.error('Error occurred while loading equipment data');
      },
    });
  }

  onRemove() {}

  resetForm() {
    this.isEdit = false;
    //const savedSubstationInstanceId = this.selectedEntity.substationTemplateInstanceId;
    this.selectedEntity.name = '';
    this.selectedEntity.sourceEquipmentIds = [];
    this.selectedEntity.sourceEquipment = [];
    this.selectedEntity.destinationEquipmentIds = [];
    this.selectedEntity.destinationEquipment = [];
    this.sourcesMultiSelect = [];
    this.destinationsMultiSelect = [];
    this.substationOptions = [];

    if (
      this.isOpenedFromSubstation &&
      this.substationTemplateInstanceIdFromSubstation
    ) {
      this.selectedEntity.substationTemplateInstanceId =
        this.substationTemplateInstanceIdFromSubstation;
      this.getAllSubstationEquipmentForSelect();
    }
    //  else if (savedSubstationInstanceId) {
    //   this.selectedEntity.substationTemplateInstanceId = savedSubstationInstanceId;
    // }

    this.substationTemplateDropdown?.selectItem(null);
    this.substationTemplateInstanceDropdown?.selectItem(null);
    this.dropdownVoltage?.selectItem(null);
    this.destinationEquipmentDropdown?.selectItem(null);
    this.sourceEquipmentDropdown?.selectItem(null);
  }

  save() {
    if (this.validInput()) {
      this.connectorSwitchService
        .createOrUpdate(this.selectedEntity)
        .subscribe({
          next: (response) => {
            const responseData = response.body;
            if (responseData?.status === 200 || responseData?.status === 'OK') {
              this.toastr.success(
                this.isEdit ? 'Updated successfully' : 'Created successfully',
              );
              this.equipmentSaved.emit();
              this.closeEditModal?.nativeElement?.click();
            } else {
              this.toastr.error(responseData?.message);
            }
          },
          error: (_) => {
            this.toastr.error('Error occurred');
          },
        });
    }
  }

  validInput() {
    if (!this.selectedEntity.name || this.selectedEntity.name.trim() === '') {
      this.toastr.warning('Please enter name');
      return false;
    } else if (
      !this.selectedEntity.baseVoltageId &&
      this.selectedEquipmentType.value != 'AcLineSegment'
    ) {
      this.toastr.warning('Please select base voltage');
      return false;
    } else if (
      !this.isEdit &&
      !this.isOpenedFromSubstation &&
      !this.selectedEntity.equipmentContainerId
    ) {
      this.toastr.warning('Please select an equipment container');
      return false;
    } else if (
      !this.isEdit &&
      !this.isOpenedFromSubstation &&
      !this.selectedEntity.substationTemplateInstanceId
    ) {
      this.toastr.warning('Please select an equipment container instance');
      return false;
    } else if (
      !this.isEdit &&
      this.selectedEntity.sourceEquipmentIds.length == 0 &&
      this.selectedEquipmentType.value == 'AcLineSegment'
    ) {
      this.toastr.warning('Please select a source Power Transformer');
      return false;
    }

    // else if (this.selectedEntity.sourceEquipmentId != null && this.selectedEntity.destinationEquipmentId != null && this.selectedEntity.sourceEquipmentId === this.selectedEntity.destinationEquipmentId) {
    //   this.toastr.warning('Source and destination cannot be the same');
    //   return false;
    // }
    return true;
  }
}
